export default __webpack_public_path__ + "static/media/802.f22a42eb.jpg";